<template>
  <div :style="getBackground">
    <div
      :style="style"
      class="uk-container uk-container-center"
    >
      <div v-if="!error">
        <LanguageMenu @on-locale-changed="localeChanged" />
        <div
          v-if="isLoading"
          style="margin:5px;"
        >
          <Spin fix>
            <Icon
              :size="35"
              type="load-c"
              class="demo-spin-icon-load"
            />
            <div class="uk-margin-small-top uk-text-small">
              Bitte haben Sie noch einen Augenblick Geduld – Just a moment, please
            </div>
          </Spin>
        </div>
        <InquiryForm
          v-if="isReady"
          :arrival="arrival"
          :aid="aid"
          :bg-color="bgColor"
          :departure="departure"
          :lang-code="liso"
          :form-token="formToken"
          :inquiry-token="inquiryToken"
          @on-complete="completed"
        />
      </div>
      <div v-else>
        <Alert type="error">
          <p class="uk-text-bold uk-text-large uk-text-danger">
            Sorry, an error occurred and we were unable to resolve it
          </p>
          <pre style="font-size: 11px;">{{ error }}</pre>
          <div class="uk-margin-small-top">Please contact
            <a href="info@tourismusnetz.com">info@tourismusnetz.com</a>
            for support.
          </div>
        </Alert>
      </div>

    </div>
  </div>
</template>
<script>
import InquiryForm from './components/InquiryForm'
import { mapState } from 'vuex'
import iView from 'iview'
import LanguageMenu from './components/LanguageMenu'
import salutationsJson from './data/salutations.json'
import countriesJson from './data/countries.json'
import languagesJson from './data/languages.json'
import inquiryJson from './data/inquiry.json'
import moment from 'moment'
import ElasticFrame from 'elasticframe'

export default {
  components: {
    InquiryForm, LanguageMenu
  },
  data () {
    return {
      isReady: false,
      isComplete: false,
      modalVisible: false,
      accommodation: {},
      error: null,
      formToken: this.$route.query.token,
      inquiryToken: this.$route.query.itoken,
      aid: parseInt(this.$route.query.aid),
      arrival: this.$route.query.anreise || '',
      width: this.$route.query.width || 650,
      bgColor: this.$route.query.bgColor || '#fff',
      departure: this.$route.query.abreise || '',
      liso: this.$route.query.liso || navigator.language.substr(0, 2)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.store.isLoading
    }),
    style () {
      return {
        maxWidth: this.width + 'px',
        backgroundColor: '#' + this.bgColor
      }
    },
    getBackground () {
      return {
        backgroundColor: '#' + this.bgColor
      }
    }
  },
  watch: {
    $route (val) {
      window.scrollTo(0, 0)
      this.iFrame.resize()
    }
  },
  async mounted () {
    await this.$store.dispatch('getIpAddress', false)
    this.iFrame = ElasticFrame.initIframe()
    this.$store.commit('setCountries', countriesJson)
    this.$store.commit('setLanguages', languagesJson)
    this.$store.commit('setSalutations', salutationsJson)
    // this.$store.commit('setIsLoading', true)
    this.error = null
    if (!this.formToken && !this.inquiryToken) {
      this.error = 'Missing token.'
      this.$store.commit('setIsLoading', false)
      return
    }

    try {
      const language = await this.$store.dispatch('setLocale', this.liso)
      await this.localeChanged(language)
    } catch (error) {
      this.error = error
      /*
      this.$bugsnagClient.notify(error, {
        metaData: {
          action: 'setLocale',
          payload: {
            liso: this.liso
          }
        }
      })
      */
    }

    this.isReady = true

    const payload = {
      formToken: this.formToken,
      inquiryToken: this.inquiryToken,
      aid: this.aid,
      arrival: this.arrival,
      departure: this.departure
    }

    if (!this.inquiryToken) {
      this.$store.commit('setIsLoading', false)
      const now = moment().format('YYYY-MM-DD HH:mm:ss')
      const emptyInquiry = inquiryJson
      emptyInquiry.created_at = now
      emptyInquiry.updated_at = now
      emptyInquiry.requested_on = moment().format('YYYY-MM-DD')
      try {
        await this.$store.dispatch('setInquiry', {
          useCache: true,
          inquiry: emptyInquiry,
          payload: {
            arrival: payload.arrival,
            departure: payload.departure
          }
        })
      } catch (error) {
        this.error = error
      }
    } else {
      this.$store.commit('setIsLoading', true)
      this.$store.commit('setLateExchange', true)
    }
    try {
      await this.$store.dispatch('getParams', payload)
    } catch (error) {
      this.error = error
    }

    this.$store.commit('setIsLoading', false)
  },
  methods: {
    async localeChanged (payload) {
      this.$i18n.locale = payload.locale
      this.$i18n.fallbackLocale = (payload.locale === 'en') ? 'de' : 'en'
      await this.$i18n.setLocaleMessage(payload.locale, payload.messages)
      iView.i18n((key, value) => this.$i18n.t(key, value))
    },
    completed (iFrame) {
      this.isComplete = true
      iFrame.resize()
    }
  }
}
</script>

<style lang="less">
  @import './assets/iview/index.css';
  @import '~iview/src/styles/index.less';
  @import '~flag-icon-css/less/flag-icon.less';
  @import '~uikit/src/less/uikit.less';
  @import './assets/iview/iview.less';
  @import '~ flex-layout-attribute/css/flex-layout-attribute.min.css';


  @flag-icon-css-path: '~flag-icon-css/flags';

  body {
    background-color: transparent;
  }

  pre {
    border: 0;
    background-color: transparent;
    margin:0;
  }

  h4 {
    color: #1353AA;
  }

  .uk-text-danger div {
    color: #AE0F2D;
  }

</style>
